import { IApiActionValidatorResponse } from "@propely/propely-typings";
import { queryClient } from "@src/index";
import { LocalData } from "@src/to-be-removed/LocalData/General/LocalData";
import { apiActionValidatorQueryKey } from "./actionValidator.service";

/**
 * Because a lot of the platform is built around the LocalData class, we need to update the LocalData class when we get new data from the API.
 * This function updates the LocalData class with the new data from the API.
 */
export const updateLocalDataActionValidator = (data: IApiActionValidatorResponse) => {
  for (const [propertyID, value] of Object.entries(data.data)) {
    LocalData.properties.getData(propertyID)?.actionValidator.setup(value);
  }

  queryClient.setQueryData(apiActionValidatorQueryKey(), data);
};

